import { Icons } from "assets";
import classNames from "classnames";
import styles from "./style.module.scss";

interface HeaderProps {
  title?: string;
  description?: string;
  Icon: any;
  iconStyle: any;
  iconContainerStyle?: any;
  isBack?: boolean;
  handleClose?: () => void;
  handleBack?: () => void;
  showBottomBorder?: boolean;
  showClose?: boolean;
}

const ModalHeader = ({
  title,
  description,
  Icon,
  iconStyle,
  iconContainerStyle,
  isBack = false,
  handleClose,
  handleBack,
  showBottomBorder = true,
  showClose = true,
}: HeaderProps) => {
  return (
    <div
      className={classNames(
        "flex items-center w-full",
        styles.header,
        !showBottomBorder && styles.headerNoBorder,
      )}
    >
      <div
        className={classNames(styles.backArrowContainer)}
        onClick={handleBack}
      >
        {isBack ? <Icons.ArrowLeft /> : null}
      </div>
      <div
        className={classNames(
          "flex items-center gap-2",
          styles.titleContainer,
          showClose && styles.reserveClose,
        )}
      >
        {Icon ? (
          <div className={iconContainerStyle ? iconContainerStyle : ""}>
            <Icon className={iconStyle ? iconStyle : ""} />
          </div>
        ) : null}
        <div className={classNames("flex flex-col gap-2.5", styles.titleText)}>
          <p>{description}</p>
          <h5 className={classNames(styles.title)}>{title}</h5>
        </div>
      </div>
      {showClose && (
        <div
          className={classNames(styles.crossContainer)}
          onClick={handleClose}
        >
          <Icons.Cross />
        </div>
      )}
    </div>
  );
};

export default ModalHeader;
